import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Dashlet from "../../controls/Dashlet";
import Icon from "../../controls/Icon";
import { setDashletEnabled } from "../dashboard/actions";
import { resetSteps } from "./actions";
function OnBoardingCard(props) {
    const { t } = useTranslation();
    const { count, desc, img, length, onClick, title, video, id, isCompleted } = props;
    const openModal = () => {
        onClick({
            title,
            video,
            desc,
            id,
            pos: { x: window.innerWidth, y: window.innerHeight },
        });
    };
    return (React.createElement("div", { className: "onboarding-card", onClick: openModal },
        React.createElement("div", { className: "onboarding-card-image-container" },
            React.createElement("img", { className: "onboarding-card-image", src: img, alt: "" })),
        React.createElement("div", { className: "onboarding-card-body" },
            React.createElement("div", { className: "onboarding-card-title-wrapper" },
                React.createElement(CounterWithCheckbox, { count: count, isChecked: isCompleted }),
                React.createElement("div", { className: "onboarding-card-title-container" },
                    React.createElement("span", { className: "onboarding-card-title" }, t(title)),
                    React.createElement("span", { className: "onboarding-card-length" }, length))),
            React.createElement("span", { className: "onboarding-card-desc" }, t(desc)))));
}
function CounterWithCheckbox(props) {
    const { count, isChecked } = props;
    const className = `onboarding-card-counter ${isChecked ? "onboarding-card-counter--checked" : ""}`;
    return (React.createElement("span", { className: className }, isChecked ? (React.createElement(Icon, { className: "onboarding-card-counter-checked-icon", name: "completed" })) : (count)));
}
function OnBoardingDashletWrapper(props) {
    const { onCardClick, steps, getMoreMods } = props;
    const { t } = useTranslation();
    const completedSteps = useSelector((state) => state.settings.onboardingsteps.steps);
    const completedStepsValues = Object.values(completedSteps);
    const isFullyCompleted = steps.length === completedStepsValues.length &&
        completedStepsValues.every((x) => x === true);
    return (React.createElement(React.Fragment, null, isFullyCompleted ? (React.createElement(CompletedOnBoardingDashlet, { getMoreMods: getMoreMods })) : (React.createElement(Dashlet, { title: t("Get Started"), className: "dashlet-onboarding" },
        React.createElement("p", { className: "onboarding-subtitle" }, t("Watch these videos to guide you on how to start modding your favorite games.")),
        React.createElement("div", { className: "onboarding-card-list" }, steps.map((step, i) => (React.createElement(OnBoardingCard, { key: i, id: step.id, title: step.title, desc: step.desc, length: step.length, img: step.img, video: step.video, count: i + 1, onClick: onCardClick, isCompleted: completedSteps[step.id] }))))))));
}
function CompletedOnBoardingDashlet(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const closeDashlet = () => {
        dispatch(setDashletEnabled("Onboarding", false));
    };
    const resetAllSteps = () => {
        dispatch(resetSteps());
    };
    return (React.createElement(Dashlet, { title: "", className: "dashlet-onboarding-completed" },
        React.createElement("div", { className: "onboarding-completed-header" },
            React.createElement("h1", null,
                "\uD83C\uDF89 ",
                t("Congratulations, you've made it!")),
            React.createElement("h4", null, t("Now you are all set up to enjoy Vortex and start modding!"))),
        React.createElement("div", { className: "onboarding-completed-body" },
            React.createElement("div", { className: "onboarding-completed-body-button" },
                React.createElement(Button, { id: "btn-more-mods", onClick: props.getMoreMods },
                    React.createElement(Icon, { name: "nexus" }),
                    t("Get more mods"))),
            React.createElement("div", { className: "onboarding-completed-body-links" },
                React.createElement("a", { onClick: resetAllSteps }, t("Watch again")),
                React.createElement("a", { onClick: closeDashlet }, t("Hide"))))));
}
export default OnBoardingDashletWrapper;
